'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Spinner = require('./Spinner.less');

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spinner = (_temp = _class = function (_React$Component) {
    (0, _inherits3.default)(Spinner, _React$Component);

    function Spinner() {
        (0, _classCallCheck3.default)(this, Spinner);
        return (0, _possibleConstructorReturn3.default)(this, (Spinner.__proto__ || (0, _getPrototypeOf2.default)(Spinner)).apply(this, arguments));
    }

    (0, _createClass3.default)(Spinner, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                { className: _Spinner2.default.wrapper + ' ' + this.props.className, style: {
                        borderColor: this.props.bordercolor,
                        width: this.props.radius,
                        height: this.props.radius } },
                _react2.default.createElement(
                    'svg',
                    { className: _Spinner2.default.spinner, viewBox: '0 0 44 44', style: {
                            width: this.props.radius,
                            height: this.props.radius,
                            borderRadius: '50%',
                            position: 'absolute',
                            top: '-4px',
                            left: '-4px' } },
                    _react2.default.createElement('circle', { className: _Spinner2.default.path, cx: '22', cy: '22', r: '20', fill: 'none', style: {
                            stroke: this.props.color
                        } })
                )
            );
        }
    }]);
    return Spinner;
}(_react2.default.Component), _class.propTypes = {
    color: _propTypes2.default.string,
    radius: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    bordercolor: _propTypes2.default.string,
    className: _propTypes2.default.string
}, _class.defaultProps = {
    className: ''
}, _temp);
exports.default = Spinner;